import React from 'react';

import { createUniqueKey } from '../../../utils';

interface ChartItemData {
    x?: number;
    y?: number;
    plotX?: number;
    plotY?: number;
    plotWidth?: number;
    barX?: number;
    barY?: number;
    barWidth?: number;
    legendX?: number;
    legendY?: number;
    range?: string;
    triangles: string[];
}

interface ChartItemProps {
    data?: ChartItemData;
    index?: number;
}

const ChartItem: React.FC<ChartItemProps> = ({
    data = {
        triangles: [],
    },
    index,
}) => {
    return (
        <g
            x={data.x}
            y={data.y}
            height={49}
            className={`chart-series-group chart-color-${index}`}
        >
            <rect
                x={data.plotX}
                y={data.plotY}
                width={data.plotWidth}
                height="25"
                className="chart-plot"
            />

            <rect
                x={data.barX}
                y={data.barY}
                width={data.barWidth}
                height="25"
                className={`chart-bar chart-color-${index}`}
            />

            <text
                x={data.legendX}
                y={data.legendY}
                fontSize="14px"
                className="chart-bar-legend"
            >
                {data.range}
            </text>

            {data.triangles.map((item, i) => (
                <polygon
                    key={createUniqueKey(i, item)}
                    points={item}
                    className={`chart-triangle chart-color-${i}`}
                />
            ))}
        </g>
    );
};

export default ChartItem;